module.exports = __webpack_public_path__ + "assets1783936157458/img/logo-duolian2.55e9dd26.png";